module.exports = __webpack_public_path__ + "img/22.51042b89.jpg";